module.exports = __webpack_public_path__ + "static/media/vbclogo.702c2617.png";